/**
 * Campos dinâmicos dos modelos de documento.
 *
 * O preenchimento acontece **uma vez, na emissão**: o texto resultante é o que
 * a paciente assina e é ele que fica gravado no documento. Reprocessar o
 * modelo na leitura reescreveria o que foi assinado.
 *
 * Vive em `comuns` porque os dois adaptadores preenchem na emissão e a tela
 * preenche na pré-visualização — três cópias da mesma substituição divergiriam.
 */

export interface CampoDinamico {
    tag: string;
    descricao: string;
}

export const CAMPOS_DINAMICOS: CampoDinamico[] = [
    { tag: '{paciente}', descricao: 'Nome completo do paciente' },
    { tag: '{cpf}', descricao: 'CPF do paciente' },
    { tag: '{procedimento}', descricao: 'Procedimento vinculado' },
    { tag: '{valor}', descricao: 'Valor do procedimento' },
    { tag: '{data}', descricao: 'Data da emissão' },
    { tag: '{profissional}', descricao: 'Profissional responsável' },
    { tag: '{clinica}', descricao: 'Nome da clínica' },
];

/** Quantos campos dinâmicos há no texto. */
export function contarCampos(corpo: string): number {
    return (corpo.match(/\{[a-zç]+\}/g) ?? []).length;
}

export interface DadosDoPreenchimento {
    paciente: string;
    cpf?: string;
    procedimento?: string;
    valorCentavos?: number;
    /** Já no formato que vai no papel: `08/09/2026`. */
    data: string;
    profissional?: string;
    clinica: string;
}

export function preencherCorpo(corpo: string, dados: DadosDoPreenchimento): string {
    const valor = dados.valorCentavos === undefined
        ? '—'
        : `R$ ${(dados.valorCentavos / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
    return corpo
        .replace(/\{paciente\}/g, dados.paciente)
        .replace(/\{cpf\}/g, dados.cpf ?? '—')
        .replace(/\{procedimento\}/g, dados.procedimento ?? '—')
        .replace(/\{valor\}/g, valor)
        .replace(/\{data\}/g, dados.data)
        .replace(/\{profissional\}/g, dados.profissional ?? '—')
        .replace(/\{clinica\}/g, dados.clinica);
}
